import React, { useEffect, useState } from 'react';
import calenderApi from '../../api/calenderApi';
import Weather from '../../assets/Weather';
import Location from '../../assets/icon/Location';
import useBgColorStore from '../../store/bgColor';
import useLocationStore from '../../store/locatonStore';

type WeatherData = {
  date: string;
  day: {
    avgtemp_c: number;
    condition: {
      icon: string;
      text: string;
    };
  };
};

const WeatherDetails = () => {
  const [weeklyWeather, setWeeklyWeather] = useState<WeatherData[]>([]);
  const [currentTemp, setCurrentTemp] = useState<number | null>(null);
  const [location, setLocation] = useState<string>('');
  const selectedLocation = useLocationStore((state) => state.selectedLocation);

  const fetchWeather = async () => {
    try {
      const response = await calenderApi.getWeatherDetails(selectedLocation?.defaultLat ,selectedLocation?.defaultLon);
      const data = response?.data;
      if (!data?.current || !data?.forecast) {
        throw new Error('Incomplete data received from the API');
      }
      setCurrentTemp(data?.current?.temp_c);
      setLocation(data?.location?.name);
      setWeeklyWeather(data?.forecast?.forecastday);
    } catch (error) {
      console.error('Error fetching weather data here :', error);
    }
  };

  useEffect(() => {
    fetchWeather();
  }, [selectedLocation.OwnerId]);

  return (
    <div
      className={`w-screen sm:w-full px-4 py-6 sm:rounded-xl  bg-sidebar-background`}
    >
      <div className="flex gap-2 text-start mb-2">
        <Weather />
        <div className="flex flex-col">
          <div className="text-4xl font-bold text-textColorGray">
            {currentTemp !== null
              ? `${Math.round(currentTemp)}°C`
              : 'Loading...'}
          </div>
          <div className="flex items-center gap-2">
            <Location />
            <div className="text-lg text-textColorGray">
              {location}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between w-full">
        {weeklyWeather?.length > 0 ? (
          weeklyWeather?.map((day, index) => {
            const date = new Date(day?.date);
            const dayName = date.toLocaleDateString('en-US', {
              weekday: 'short',
            });
            const temp = Math.round(day?.day?.avgtemp_c);
            const icon = `https:${day?.day?.condition.icon}`;

            return (
              <div className="flex flex-col items-center" key={index}>
                <img src={icon} alt="Weather Icon" className="w-10 h-10 my-2" />
                <div className="text-lg font-medium text-textColorGray">
                  {temp}°
                </div>
                <div className="text-sm text-textColorGray">
                  {dayName}
                </div>
              </div>
            );
          })
        ) : (
          <div>Loading weekly weather...</div>
        )}
      </div>
    </div>
  );
};

export default WeatherDetails;
